const ClockIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Icon/clock'>
      <g id='Vector'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12Z'
          fill='currentColor'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12 5.5C12.2761 5.5 12.5 5.72386 12.5 6V11.7929L14.3536 13.6464C14.5488 13.8417 14.5488 14.1583 14.3536 14.3536C14.1583 14.5488 13.8417 14.5488 13.6464 14.3536L11.6464 12.3536C11.5527 12.2598 11.5 12.1326 11.5 12V6C11.5 5.72386 11.7239 5.5 12 5.5Z'
          fill='currentColor'
        />
      </g>
    </g>
  </svg>
)

export default ClockIcon
